function _define_property(obj, key, value) {
    if (key in obj) {
        Object.defineProperty(obj, key, {
            value: value,
            enumerable: true,
            configurable: true,
            writable: true
        });
    } else {
        obj[key] = value;
    }
    return obj;
}
function _object_spread(target) {
    for(var i = 1; i < arguments.length; i++){
        var source = arguments[i] != null ? arguments[i] : {};
        var ownKeys = Object.keys(source);
        if (typeof Object.getOwnPropertySymbols === "function") {
            ownKeys = ownKeys.concat(Object.getOwnPropertySymbols(source).filter(function(sym) {
                return Object.getOwnPropertyDescriptor(source, sym).enumerable;
            }));
        }
        ownKeys.forEach(function(key) {
            _define_property(target, key, source[key]);
        });
    }
    return target;
}
function ownKeys(object, enumerableOnly) {
    var keys = Object.keys(object);
    if (Object.getOwnPropertySymbols) {
        var symbols = Object.getOwnPropertySymbols(object);
        if (enumerableOnly) {
            symbols = symbols.filter(function(sym) {
                return Object.getOwnPropertyDescriptor(object, sym).enumerable;
            });
        }
        keys.push.apply(keys, symbols);
    }
    return keys;
}
function _object_spread_props(target, source) {
    source = source != null ? source : {};
    if (Object.getOwnPropertyDescriptors) {
        Object.defineProperties(target, Object.getOwnPropertyDescriptors(source));
    } else {
        ownKeys(Object(source)).forEach(function(key) {
            Object.defineProperty(target, key, Object.getOwnPropertyDescriptor(source, key));
        });
    }
    return target;
}
import { jsx as _jsx } from "react/jsx-runtime";
import { useMemo } from 'react';
import observabilityConfig from '../../internal/config';
import ObservabilityConfigContext from '../../internal/config/ObservabilityConfigContext';
import { DEFAULT_OBSERVABILITY_CONFIG } from '../../internal/constants';
import useObservabilityConfig from '../../public/useObservabilityConfig';
const getInitConfig = ()=>{
    // If the config is not initialized, we don't want to log an error.
    // We're only interested in reading possible context values
    // (as if it were a <ObservabilityProvider>) which are not critical.
    //
    // Once we move to a declarative initialization, we won't be needing
    // to read from the config anymore, as the <ObservabilityProvider> will
    // be the only way to initialize the `sdk/observability`.
    return observabilityConfig.isInitialized() ? observabilityConfig.getAll() : undefined;
};
export default function ObservabilityConfigProvider({ config, children }) {
    const parentConfig = useObservabilityConfig();
    const initialConfig = getInitConfig();
    const defaultConfig = DEFAULT_OBSERVABILITY_CONFIG;
    const mergedConfig = useMemo(()=>{
        var _defaultConfig_errors, _initialConfig_errors, _parentConfig_errors, _config_errors;
        return _object_spread_props(_object_spread({}, initialConfig, parentConfig, config), {
            errors: _object_spread_props(_object_spread({}, initialConfig === null || initialConfig === void 0 ? void 0 : initialConfig.errors, parentConfig === null || parentConfig === void 0 ? void 0 : parentConfig.errors, config.errors), {
                projects: _object_spread({}, defaultConfig === null || defaultConfig === void 0 ? void 0 : (_defaultConfig_errors = defaultConfig.errors) === null || _defaultConfig_errors === void 0 ? void 0 : _defaultConfig_errors.projects, initialConfig === null || initialConfig === void 0 ? void 0 : (_initialConfig_errors = initialConfig.errors) === null || _initialConfig_errors === void 0 ? void 0 : _initialConfig_errors.projects, parentConfig === null || parentConfig === void 0 ? void 0 : (_parentConfig_errors = parentConfig.errors) === null || _parentConfig_errors === void 0 ? void 0 : _parentConfig_errors.projects, config === null || config === void 0 ? void 0 : (_config_errors = config.errors) === null || _config_errors === void 0 ? void 0 : _config_errors.projects)
            })
        });
    }, [
        parentConfig,
        initialConfig,
        defaultConfig,
        config
    ]);
    return /*#__PURE__*/ _jsx(ObservabilityConfigContext.Provider, {
        value: mergedConfig,
        children: children
    });
}

//# sourceMappingURL=ObservabilityConfigProvider.js.map